import React from 'react';
// import UrlWatcher from '@bd/bdcore-data/build/UrlWatcher';
import StackLoader from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import configuration from './configuration';
import './styles';
import AboutUs from './pages/AboutUs';
import Index from './pages/IndexPage';
import MyFavorites from './pages/MyFavorites/Index';
import PasswordReset from './pages/MyFavorites/PasswordReset';
import Communities from './pages/Communities';
import CommunityDetail from './pages/CommunityDetail';
import Homes from './pages/Homes';
import Plans from './pages/Plans';
import PlanDetail from './pages/PlanDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import HomeDetail from './pages/HomeDetail';
import OurBuyingProcess from './pages/OurBuyingProcess';
import OurConstructionProcess from './pages/OurConstructionProcess';
import LuxuryFeatures from './pages/LuxuryFeatures';
import Testimonials from './pages/Testimonials';
import Blogposts from './pages/Blogposts';
import BlogpostDetail from './pages/BlogpostDetail';
import ContactUs from './pages/ContactUs';
import WarrantyInformationRequest from './pages/WarrantyInformationRequest';
import RealtorContact from './pages/RealtorContact';
import VendorRegistration from './pages/VendorRegistration';
import ImageGallery from './pages/ImageGallery';
import VideoGallery from './pages/VideoGallery';
import NoRoute from './pages/NoRoute';

ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <StackLoader
      stack="RegionalSimple"
      components={[
        { override: 'Index', component: Index },
        { override: 'HomesList', component: Homes },
        { override: 'HomeDetail', component: HomeDetail },
        { override: 'CommunityDetail', component: CommunityDetail },
        { override: 'CommunitiesList', component: Communities },
        { override: 'PlansList', component: Plans },
        { override: 'PlanDetail', component: PlanDetail },
        { override: 'BlogpostList', component: Blogposts },
        { override: 'BlogpostDetail', component: BlogpostDetail },
        { override: 'NoRoute', component: NoRoute },
      ]}
      routes={[
        { name: 'about-us', exact: true, path: '/about-us', component: AboutUs },
        { name: 'contact-us', exact: true, path: '/contact-us', component: ContactUs },
        { name: 'favorites', exact: true, path: '/favorites', component: MyFavorites },
        { name: 'image-gallery', exact: true, path: '/image-gallery', component: ImageGallery },
        { name: 'image-gallery', exact: true, path: '/image-gallery/:category', component: ImageGallery },
        { name: 'luxury-features', exact: true, path: '/luxury-features', component: LuxuryFeatures },
        { name: 'our-buying-process', exact: true, path: '/our-buying-process', component: OurBuyingProcess },
        { name: 'our-construction-process', exact: true, path: '/our-construction-process', component: OurConstructionProcess },
        { name: 'password-reset', exact: true, path: '/my-favorites/password-reset', component: PasswordReset },
        { name: 'privacy-policy', exact: true, path: '/privacy-policy', component: PrivacyPolicy },
        { name: 'realtor-contact', exact: true, path: '/realtor-contact', component: RealtorContact },
        { name: 'testimonials', exact: true, path: '/testimonials', component: Testimonials },
        { name: 'vendor-registration', exact: true, path: '/vendor-registration', component: VendorRegistration },
        { name: 'media-and-press', exact: true, path: '/media-and-press', component: VideoGallery },
        { name: 'media-and-press-filtered', exact: true, path: '/media-and-press/:gallery', component: VideoGallery },
        { name: 'warranty-information-request', exact: true, path: '/warranty-information-request', component: WarrantyInformationRequest },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js